import type { Comparator } from './filterGroup';

export const inComparator: Comparator = {
  key: 'in',

  label: 'is',

  pluralLabel: 'is any of',
};

export const notInComparator: Comparator = {
  key: 'nin',

  label: 'is not',

  pluralLabel: 'is not any of',
};

export const gteComparator: Comparator = {
  key: 'gte',

  label: '≥',
};

export const lteComparator: Comparator = {
  key: 'lte',

  label: '≤',
};

export const eqComparator: Comparator = {
  key: 'eq',
  label: 'equal to',
  pluralLabel: 'equals',
};

export const neqComparator: Comparator = {
  key: 'ne',
  label: 'not equal to',
  pluralLabel: 'does not equal',
};
